/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/free-mode";
import "./Team.css";
import team1 from "./../assets/images/team/team-1.png";
import team2 from "./../assets/images/team/team-2.png";
import team3 from "./../assets/images/team/team-3.png";
import { Fade } from "react-reveal";

export default function Team() {
  return (
    <div id="team">
      <div className="teamSec container-fluid">
        <Fade bottom>
          <div className="teamCard">
            <h3>فريق العمل</h3>
            <Swiper
              slidesPerView={1}
              spaceBetween={20}
              autoplay
              navigation
              loop={true}
              freeMode={true}
              pagination={{
                clickable: true,
              }}
              modules={[Navigation, FreeMode, Pagination]}
              breakpoints={{
                576: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                767: {
                  slidesPerView: 2,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
              }}
              className="swiper-container"
            >
              <SwiperSlide>
                <div className="teamMember">
                  <img src={team1} alt="team" />
                  <h4>نجاة البلوشي</h4>
                  <p>مقيم عقاري </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="teamMember">
                  <img src={team2} alt="team" />
                  <h4>عبد الخالد البوسعيدي</h4>
                  <p>مدير إدارة التقييم العقاري</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="teamMember">
                  <img src={team3} alt="team" />
                  <h4>مها العلوية</h4>
                  <p>أخصائي إعلام وتسويق</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </Fade>
      </div>
    </div>
  );
}
